<template>
  <div class="video">
    <PlayIcon v-if="!isPlaying" class="icon" />
    <!-- eslint-disable-next-line vuejs-accessibility/media-has-caption }} -->
    <video
      ref="videoRef"
      v-bind="$attrs"
      @pause="onPlayStop"
      @ended="onPlayStop"
      @play="onPlayStart"
      @click.prevent="togglePlay"
    >
      <source :type="type" :src="url" :alt="alt">
    </video>
  </div>
</template>

<script lang="ts" setup>
import PlayIcon from '@images/play.svg?component';
import { ref } from 'vue';

interface Props {
  url: string;
  type?: string;
  alt?: string;
}
defineProps<Props>();

const videoRef = ref();
const isPlaying = ref(false);

const onPlayStop = () => {
  if (!videoRef.value) return;
  if (videoRef.value.seeking) return;
  isPlaying.value = false;
  videoRef.value.controls = false;
};

const onPlayStart = () => {
  if (!videoRef.value) return;
  isPlaying.value = true;
  videoRef.value.controls = true;
};

const togglePlay = async () => {
  if (!videoRef.value) return;
  if (videoRef.value.paused || videoRef.value.ended) {
    videoRef.value.play();
  } else {
    videoRef.value.pause();
  }
  // No else clause for pause because that happens automatically
  // on click if the video is playing
};

</script>

<style lang="scss" scoped>
.video {
  @apply w-full h-full rounded-4;
  @apply cursor-pointer;
  @apply overflow-hidden;

  .icon {
    @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2;
    @apply w-10 h-10;
    @apply text-white;
  }

  video {
    @apply w-full h-full object-contain;
  }
}
</style>
